/**
 * Coalesce async work to a single in-flight invocation.
 * Further {@link InFlightCoalesce.request} calls while pending are no-ops;
 * the next request after settle starts a new run (#1574 Bugbot: avoid trailing-debounce starvation).
 */
export type InFlightCoalesce = {
  request: () => void
  isInFlight: () => boolean
}

export function createInFlightCoalesce(run: () => Promise<void>): InFlightCoalesce {
  let inFlight: Promise<void> | null = null
  return {
    request() {
      if (inFlight != null) {
        return
      }
      // Start `run` immediately (do not defer behind Promise.then) so callers see work begin
      // on the same turn — important when thrashing request() from a tight retry loop.
      inFlight = Promise.resolve(run())
        .catch(() => {
          /* run is responsible for logging; swallow so coalesce always clears */
        })
        .finally(() => {
          inFlight = null
        })
    },
    isInFlight() {
      return inFlight != null
    }
  }
}
